import React from 'react';

import { IBdsActivityPill } from '../../../interfaces/bdsActivityPill';

import './BdsActivityPill.scss';

const BdsActivityPill = ({ label, variant, color, pictogram, currency, className }: IBdsActivityPill) => {
  const classNames = ['bds-activity-pill', variant, color, className].join(' ');

  const renderContent = () => {
    return (
      <>
        {pictogram && <pictogram.component className="bds-activity-pill-icon pictogram" />}
        {label}
        {currency && <currency.component className="bds-activity-pill-icon" />}
      </>
    );
  };

  return <span className={classNames}>{renderContent()}</span>;
};

export default BdsActivityPill;
